import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';
import { SmsTemplate } from '@models/sms-template';

export const SMS_BODY_MAX_LENGTH = 240;

export interface SmsFormType {
  body: FormControl<string>;
  to: FormControl<string[]>;
}

export class SmsForm extends FormGroup<SmsFormType> {
  get body(): FormControl<string> {
    return this.controls.body;
  }

  get bodyErrorMessage(): ErrorMessage | null {
    return FormHelper.composeErrorMessages(this.body, [
      { method: 'getEmptyErrorMessage', args: ['Le message est requis'] },
      { method: 'getMaxLengthErrorMessage', args: ["Le message peut contenir jusqu'à #value# caractères maximum"] }
    ]);
  }

  get to(): FormControl<string[]> {
    return this.controls.to;
  }

  constructor() {
    super({
      body: new FormControl('', [Validators.required, Validators.maxLength(SMS_BODY_MAX_LENGTH)]),
      to: new FormControl([])
    });
  }

  fromSmsTemplate(smsTemplate: SmsTemplate): void {
    this.body.patchValue(smsTemplate.body);
    this.to.patchValue(smsTemplate.to);
  }

  toSmsTemplate(): SmsTemplate {
    return new SmsTemplate(this.body.value, this.to.value);
  }
}
